var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"box",class:{ lighter: _vm.lighter },on:{"click":_vm.handleClick}},[_vm._v(" "+_vm._s(_vm.$props.label)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }